module.exports = __webpack_public_path__ + "img/证书1.154be7bf.jpg";